module.exports = __webpack_public_path__ + "media/img/event/Scholarships2u_Virtual-Scholarship-Fair-2020-Banner-7403a62377edec49d483530f842b35e9.svg";